import { Component, Input, OnInit } from '@angular/core';
import { BrowseComponent } from '@shared/components/browse/abstract.browse.component';
import { Pagination } from '@core/bean/pagination';
import { CommonsService } from '@core/service/commons.service';
import { NzModalService } from 'ng-zorro-antd';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrowseConfig } from '@core/bean/browse-config';
import { JyActionService } from '../../../../routes/jy-authorization/permission/jy-action.service';
import { Sort } from '@core/bean/sort';
import { Direction } from '@core/bean/direction';


/**
 * 权限-动作浏览按钮
 */
@Component({
  selector: 'action-browse',
  templateUrl: './action.browse.component.html',
})
export class ActionBrowseComponent implements BrowseComponent, OnInit {

  static componentName = 'ActionBrowseComponent';

  @Input() config: BrowseConfig;
  @Input() onOk: (data: any | [any]) => void;
  @Input() onCancel: () => void;

  visible = false;
  pagination: Pagination = new Pagination();

  constructor(
    private commonsService: CommonsService,
    private modalService: NzModalService,
    private jyActionService: JyActionService,
  ) {
    this.pagination.getData = function(params: HttpParams): Observable<any> {
      return jyActionService.query(params);
    };
  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    if (this.config.searchData) {
      this.pagination.searchData = this.config.searchData;
    }
    this.pagination.addInitSort(new Sort('permission.name', Direction.ASC));
    this.pagination.addInitSort(new Sort('name', Direction.ASC));
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    }
  }


  selectData(data) {
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }
}
